<script>
    // выбор из двух картинок

    import ImageCDN from '../ImageCDN.svelte';

    export let wrapper;
    export let data;
    export let reward;
    const check = () => {
        return true;
    }
    
    let bonus = 0;
    let params = Array.isArray(data.params) ? data.params[0] : data.params;
    let questions = [...data.options];
    let question = questions.shift();
    
    const handlerNext = (value) => {
        let qw = wrapper.querySelector('[data-question]'),
            qbtn = wrapper.querySelectorAll('button'),
            progress = wrapper.querySelector('.progress-bar');
    
        qbtn.forEach(el => {el.disabled = true});
        
        if (question.answer.toString() === value.toString()) {
            qw.classList.add('border-bottom', 'border-3', 'border-success');
            bonus += +question.bonus;
        } else {
            qw.classList.add('border-bottom', 'border-3', 'border-danger');
        }
    
        progress.style = 'width: ' + ((data.options.length - questions.length) * 100 / data.options.length) + '%';
        
        setTimeout(() => {
            qbtn.forEach(el => {el.disabled = false});
            qw.classList.remove('border-bottom', 'border-3', 'border-success', 'border-danger');
            
            if (questions.length) {
                question = questions.shift();
            } else {
                reward(bonus);
            }
        }, 1000);
    };
</script>

<div>
    <div class="progress mb-3">
        <div class="progress-bar progress-bar-striped bg-success" role="progressbar" style="width: 0%"></div>
    </div>
    
    <div class="card" data-question>
        <div class="card-body">
            {#if question.label}
                <h5 class="card-title text-md-center mb-2">{question.label}</h5>
            {/if}
            
            <div class="row">
                <div class="col-6">
                    <div on:click={() => handlerNext(1)}>
                        <ImageCDN src="{question.image_1 ? question.image_1 : '#'}" class="rounded-1 d-block mx-auto" alt="image_1" style="width: 100%; object-fit: contain; object-position: center center;" />
                        {#if question.description_1}
                            <p class="text-muted text-md-center m-0">{question.description_1}</p>
                        {/if}
                    </div>
                </div>
                <div class="col-6">
                    <div on:click={() => handlerNext(2)}>
                        <ImageCDN src="{question.image_2 ? question.image_2 : '#'}" class="rounded-1 d-block mx-auto" alt="image_2" style="width: 100%; object-fit: contain; object-position: center center;" />
                        {#if question.description_2}
                            <p class="text-muted text-md-center m-0">{question.description_2}</p>
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <div class="row mt-3">
        {#if params.button_1}
            <div class="{params.button_2 ? 'col-6' : 'col-12'} mb-1">
                <button type="button" class="btn btn-primary btn-block btn-lg" on:click={() => handlerNext(1)}>{params.button_1}</button>
            </div>
        {/if}
        {#if params.button_2}
            <div class="{params.button_1 ? 'col-6' : 'col-12'} mb-1">
                <button type="button" class="btn btn-primary btn-block btn-lg" on:click={() => handlerNext(2)}>{params.button_2}</button>
            </div>
        {/if}
    </div>
</div>

<style>
    img {
        display: block;
        margin: 0 auto;
        min-width: 200px;
        width: 100%;
        max-width: 500px;
        height: auto;
        object-fit: cover;
        object-position: center center;
    }
</style>
